// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconButton {
  outline: none;
  margin: 0;
  padding: 0;
  padding: 4px;
  border-radius: 50%;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  line-height: 0;
  flex-shrink: 0;
  cursor: pointer;
  background-color: transparent;
  color: var(--color_neutral_800);
}
.IconButton:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.IconButton:active {
  background-color: rgba(0, 0, 0, 0.08);
}
.IconButton:focus-visible {
  box-shadow: 0 0 0 2px var(--color_primary_500);
}
.IconButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/IconButton/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,2BAAA;EAAA,wBAAA;EAAA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EAEA,6BAAA;EACA,+BAAA;AAAF;AAEE;EACE,qCAAA;AAAJ;AAEE;EACE,qCAAA;AAAJ;AAEE;EACE,8CAAA;AAAJ;AAEE;EACE,YAAA;EACA,mBAAA;AAAJ","sourcesContent":[".IconButton {\n  outline: none;\n  margin: 0;\n  padding: 0;\n  padding: 4px;\n  border-radius: 50%;\n  width: fit-content;\n  height: fit-content;\n  line-height: 0;\n  flex-shrink: 0;\n  cursor: pointer;\n\n  background-color: transparent;\n  color: var(--color_neutral_800);\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n  }\n  &:active {\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n  &:focus-visible {\n    box-shadow: 0 0 0 2px var(--color_primary_500);\n  }\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
